import type { FC } from 'react';

import { marketingLinks } from 'utils/siteLinks';

import styles from './AuthPrivacyConsent.module.scss';

interface AuthPrivacyConsentProps {
  /** Required checkbox (registration). Login can use notice-only mode. */
  mode: 'checkbox' | 'notice';
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  isInvalid?: boolean;
  errorText?: string;
  disabled?: boolean;
}

const privacyPolicyLink = (
  <a
    href={marketingLinks.privacy}
    className={styles.link}
    target='_blank'
    rel='noopener noreferrer'
  >
    Политикой обработки персональных данных
  </a>
);

const consentProcessingLink = (
  <a
    href={marketingLinks.privacyConsent}
    className={styles.link}
    target='_blank'
    rel='noopener noreferrer'
  >
    согласен на обработку моих персональных данных
  </a>
);

export const AuthPrivacyConsent: FC<AuthPrivacyConsentProps> = ({
  mode,
  checked = false,
  onChange,
  isInvalid = false,
  errorText,
  disabled = false,
}) => {
  if (mode === 'notice') {
    return (
      <p className={styles.notice} role='note'>
        Входя в аккаунт, вы подтверждаете согласие на обработку персональных данных (в соответствии с{' '}
        {privacyPolicyLink}).
      </p>
    );
  }

  return (
    <div className={styles.block}>
      <label className={`${styles.agreement}${isInvalid ? ` ${styles.invalid}` : ''}`}>
        <input
          type='checkbox'
          className={styles.checkbox}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        <span className={styles.customCheckbox} aria-hidden />
        <span className={styles.labelText}>
          Я {consentProcessingLink} (в соответствии с {privacyPolicyLink})
        </span>
      </label>
      {isInvalid && errorText ? <div className={styles.error}>{errorText}</div> : null}
    </div>
  );
};
